import type { AboutUs, Statistics } from '../../types/api';
import { Button, Section, Stats } from '../ui';
import { paragraphs } from '../../utils/text';

/** « Qui sommes-nous »: présentation à gauche, chiffres clés à droite. */
export default function AboutIntro({ about, stats }: { about: AboutUs | null; stats: Statistics | null }) {
  if (!about) return null;
  const body = paragraphs(about.description).slice(0, 2);
  return (
    <Section eyebrow="Qui sommes-nous" heading={about.title} pattern="top-right" background="white">
      <div className="grid gap-12 lg:grid-cols-[1.9fr_1fr] lg:gap-20">
        <div>
          <div className="space-y-6 text-[1.0625rem] leading-relaxed text-black">
            {body.map((p) => <p key={p.slice(0, 24)}>{p}</p>)}
          </div>
          <div className="mt-10"><Button to="/about" variant="secondary">À propos de nous</Button></div>
        </div>
        {stats && (
          <Stats
            stats={[
              { value: String(stats.works), label: 'Réalisations' },
              { value: String(stats.sectors), label: 'Secteurs d’intervention' },
              { value: String(stats.services), label: 'Services' },
            ]}
          />
        )}
      </div>
    </Section>
  );
}
